import type {
  AiChatTimelineItem,
  AiChatUserQuestion,
} from "@/lib/types/ai-chat";

export function isUserQuestionItem(item: AiChatTimelineItem) {
  return (
    item.kind === "tool_activity" &&
    item.payload.toolName === "request_user_input_async" &&
    Boolean(parseUserQuestion(item.payload.userQuestion))
  );
}

export function parseUserQuestion(
  value: unknown,
): AiChatUserQuestion | undefined {
  if (!value || typeof value !== "object") return undefined;
  const question = value as Record<string, unknown>;
  if (
    typeof question.requestId !== "string" ||
    (question.status !== "pending" && question.status !== "answered") ||
    !Array.isArray(question.questions) ||
    question.questions.length < 1 ||
    question.questions.length > 3
  )
    return undefined;
  const questions: unknown[] = question.questions;
  if (
    !questions.every((entry) => {
      if (!entry || typeof entry !== "object") return false;
      const fields = entry as Record<string, unknown>;
      return (
        typeof fields.id === "string" &&
        typeof fields.title === "string" &&
        Array.isArray(fields.options) &&
        fields.options.every((option: unknown) => typeof option === "string")
      );
    })
  )
    return undefined;
  if (question.answers !== undefined) {
    if (!Array.isArray(question.answers)) return undefined;
    const answers: unknown[] = question.answers;
    if (
      !answers.every((answer) => {
        if (!answer || typeof answer !== "object") return false;
        const fields = answer as Record<string, unknown>;
        return (
          typeof fields.questionId === "string" &&
          typeof fields.answer === "string"
        );
      })
    )
      return undefined;
  }
  return value as AiChatUserQuestion;
}
